// extracted by mini-css-extract-plugin
module.exports = {"bodyImg":"App_bodyImg__3lk4j"};